(function(){
  function measure(){
    var d=document.documentElement,b=document.body;
    return Math.max(b?b.scrollHeight:0,d?d.scrollHeight:0,b?b.offsetHeight:0,d?d.offsetHeight:0);
  }
  function send(){ try{ parent.postMessage({type:'odelise-sales-bridge-height',height:measure()}, '*'); }catch(e){} }
  window.addEventListener('load', function(){ send(); setTimeout(send,300); setTimeout(send,1200); setTimeout(send,2500); });
  window.addEventListener('resize', send);
  window.addEventListener('message', function(e){ if(e && e.data && e.data.type==='odelise-sales-bridge-measure') send(); });
  setInterval(send, 1500);
})();


(function(){
  var root=document.getElementById('back-support-belt-offer-native');
  var dest='https://odelise.com/products/baresupport-back-belt';
  function shouldRoute(el){
    if(!el) return false;
    var txt=((el.getAttribute('data-text-value')||'')+' '+(el.textContent||'')+' '+(el.getAttribute('title')||'')+' '+(el.getAttribute('action')||'')).toLowerCase();
    return txt.indexOf('get ')>-1 || txt.indexOf('try ')>-1 || txt.indexOf('order')>-1 || txt.indexOf('check availability')>-1 || txt.indexOf('38%')>-1 || txt.indexOf('today only')>-1 || txt.indexOf('route')>-1;
  }
  document.addEventListener('click',function(e){
    var el=e.target.closest && e.target.closest('a,button');
    if(!el || (root && !root.contains(el))) return;
    var href=el.getAttribute('href')||'';
    if(href && href.indexOf('#')!==0 && href.indexOf('javascript:')!==0) return;
    if(shouldRoute(el)){e.preventDefault(); window.location.href=dest;}
  },true);
})();